import React, { useState, useEffect } from "react";
import "./i18n/config";
import { Row, Col, Table } from "react-bootstrap";
import * as moment from 'moment';
import { useTranslation } from "react-i18next";


function CustomerReqTableComponent(props) {

    const { t } = useTranslation();

    return (
        <div className="box cust-req-tbl-wrap">

            <h4>{props.message}</h4>
            <Table hover className="ordersTable">
                <thead>
                    <tr>
                        <th>{t("ReqNum")}</th>
                        <th>{t("Date")}</th>
                        <th>{t("ReqMsg")}</th>
                        <th>{t("ReplyNum")}</th>

                    </tr>
                </thead>
                <tbody>

                    {props.allCustomerRequests.map((currentReq, index) => {
                        return <>
                            <tr key={index} className="order-item ">
                                <td>{currentReq.requestId}</td>
                                <td>{moment(currentReq.createdOn).format('DD/MM/YYYY')} </td>
                                <td> {currentReq.requestContent}</td>
                                <td>{currentReq.resolutionContent}</td>
                            </tr>


                        </>
                    })}
                </tbody>
            </Table>
        </div>
    );
}

export default CustomerReqTableComponent;
